import { render, staticRenderFns } from "./dismiss-action.vue?vue&type=template&id=33395290&scoped=true"
import script from "./dismiss-action.vue?vue&type=script&lang=js"
export * from "./dismiss-action.vue?vue&type=script&lang=js"
import style0 from "./dismiss-action.vue?vue&type=style&index=0&id=33395290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33395290",
  null
  
)

export default component.exports